import { lazy, ComponentType, LazyExoticComponent } from 'react';

import { Urls } from 'shared/constants/urls';
import { Layouts } from 'shared/constants/layouts';

export type TLayout = {
  type: Layouts;
  hasQueue: boolean;
  notClosable: boolean;
};

export interface IRouteItem {
  id: number | string;
  path: string;
  protected: boolean;
  layout?: TLayout;
  component: LazyExoticComponent<ComponentType<any>>;
}

export const ROUTES: IRouteItem[] = [
  {
    id: 1,
    path: Urls.HomePage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: true
    },
    component: lazy(() => import('./HomePage'))
  },
  {
    id: 2,
    path: Urls.PatientsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./PatientsPage'))
  },
  {
    id: 3,
    path: Urls.ConsultationsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./ConsultationsPage'))
  },
  {
    id: 4,
    path: Urls.TransactionsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./TransactionsPage'))
  },
  // {
  //   id: 5,
  //   path: Urls.EventsPage,
  //   protected: true,
  //   layout: {
  //     type: Layouts.Base,
  //     hasQueue: true,
  //     notClosable: false
  //   },
  //   component: lazy(() => import('./EventsPage'))
  // },
  // {
  //   id: 6,
  //   path: Urls.ReportsPage,
  //   protected: true,
  //   layout: {
  //     type: Layouts.Base,
  //     hasQueue: true,
  //     notClosable: false
  //   },
  //   component: lazy(() => import('./ReportsPage'))
  // },
  {
    id: 7,
    path: Urls.SettingsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: false,
      notClosable: false
    },
    component: lazy(() => import('./SettingsPage'))
  },
  {
    id: 8,
    path: Urls.HealthCheck,
    protected: false,
    component: lazy(() => import('./HealthCheckPage'))
  },
  {
    id: 9,
    path: Urls.LoginPage,
    protected: false,
    component: lazy(() => import('./LoginPage'))
  },
  {
    id: 10,
    path: Urls.ForgotPassword,
    protected: false,
    component: lazy(() => import('./ForgotPasswordPage'))
  },
  {
    id: 11,
    path: Urls.PasswordReset,
    protected: false,
    component: lazy(() => import('./ResetPasswordPage'))
  },
  {
    id: 12,
    path: Urls.IndividualPage,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    protected: false,
    component: lazy(() => import('./IndividualPage'))
  },
  {
    id: 13,
    path: Urls.IndividualConsultationPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./IndividualConsultationPage'))
  },
  {
    id: 14,
    path: Urls.OrdersPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./OrdersPage'))
  },
  {
    id: 15,
    path: Urls.IndividualTransactionPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./IndividualTransactionsPage'))
  },
  {
    id: 16,
    path: Urls.IndividualOrderPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./IndividualOrderPage'))
  },
  {
    id: 17,
    path: Urls.ConsultationsByPatient,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./ConsultationsPage'))
  },
  {
    id: 18,
    path: Urls.TwoFactor,
    protected: false,
    component: lazy(() => import('./TwoFactorPage'))
  },
  {
    id: 19,
    path: Urls.SignUpAffiliateAdminPage,
    protected: false,
    component: lazy(() => import('./ResetPasswordPage'))
  },
  {
    id: 20,
    path: Urls.LabOrdersPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./LabOrdersPage'))
  },
  {
    id: 19,
    path: Urls.IndividualLabOrderPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./IndividualLabOrderPage'))
  },
  {
    id: 20,
    path: Urls.LabOrderResultsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./LabOrderResultsPage'))
  },
  {
    id: 21,
    path: Urls.Messages,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./MessagePage'))
  },
  {
    id: 22,
    path: Urls.JourneyTemplatePage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./JourneyTemplatePage'))
  },

  {
    id: 23,
    path: Urls.IndividualJourneyTemplatePage,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    protected: false,
    component: lazy(() => import('./IndividualJourneyTemplatePage'))
  },
  {
    id: 24,
    path: Urls.IndividualProductPage,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    protected: false,
    component: lazy(() => import('./IndividualProductPage'))
  },
  {
    id: 25,
    path: Urls.SubscriptionsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./SubscriptionPage'))
  },

  {
    id: 26,
    path: Urls.ProductsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./ProductPage'))
  },
  {
    id: 27,
    path: Urls.IndividualSubscriptionPage,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    protected: false,
    component: lazy(() => import('./IndividualSubscriptionPage'))
  },
  {
    id: 28,
    path: Urls.EcommerceOrdersPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./EcommerceOrderPage'))
  },
  {
    id: 29,
    path: Urls.AddEcommerceOrderPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./AddEcommerceOrderPage'))
  },
  {
    id: 30,
    path: Urls.EditEcommerceOrderPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./EditEcommerceOrderPage'))
  },
  {
    id: 31,
    path: Urls.IndividualEcommerceOrderPage,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    protected: false,
    component: lazy(() => import('./IndividualEcommerceOrderPage'))
  },
  {
    id: 32,
    path: Urls.CouponsPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./CouponsPage'))
  },
  {
    id: 33,
    path: Urls.IndividualCouponPage,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    protected: false,
    component: lazy(() => import('./IndividualCouponPage'))
  },
  {
    id: 34,
    path: Urls.AddSubscriptionPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./AddSubscriptionPage'))
  },
  {
    id: 35,
    path: Urls.EditSubscriptionPage,
    protected: true,
    layout: {
      type: Layouts.Base,
      hasQueue: true,
      notClosable: false
    },
    component: lazy(() => import('./EditSubscriptionPage'))
  }
];
